"use strict";
var fails = require("../internals/fails");
var globalThis = require("../internals/global-this");
var $RegExp = globalThis.RegExp;
var UNSUPPORTED_Y = fails(function() {
  var re = $RegExp("a", "y");
  re.lastIndex = 2;
  return re.exec("abcd") !== null;
});
var MISSED_STICKY = UNSUPPORTED_Y || fails(function() {
  return !$RegExp("a", "y").sticky;
});
var BROKEN_CARET = UNSUPPORTED_Y || fails(function() {
  var re = $RegExp("^r", "gy");
  re.lastIndex = 2;
  return re.exec("str") !== null;
});
module.exports = {
  BROKEN_CARET,
  MISSED_STICKY,
  UNSUPPORTED_Y
};
